import React from "react";
import {useNavigate, useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";

import TabsBar from "../../components/TabsBar";
import TabPanel from "../../components/TabsBar/TabPanel";
import useTabs from "../../components/TabsBar/useTabs";
import {StationPermissions} from "./PermissionCard/StationPermissions";
import WorkgroupPermissions from "./PermissionCard/WorkgroupPermissions";
import Header from "./Header";
import CardBasicInfo from "./CardBasicInfo";
import CardPassword from "./CardPassword";
import {useUserMutation, useUserQuery} from "./query";
import CardContact from "./CardContact";

import Container from "@mui/material/Container";
import {Grid} from "@mui/material";
import SettingsCard from "./SettingsCard";
import {useAuth} from "../../auth/AuthProvider";


const User = () => {
    const {t} = useTranslation(['user']);
    const {userId} = useParams();
    const {workgroupAuthorization} = useAuth();
    const navigate = useNavigate();

    const userQuery = useUserQuery(userId);
    const userMutation = useUserMutation(userId, {
        onSuccess: async (data, variables) => {
            if (variables.shouldRedirect) {
                await navigate("/users");
            }
        }
    });
    const userPwdMutation = useUserMutation(userId);
    const userContactMutation = useUserMutation(userId);

    const tabs = useTabs({tabs: [
            {label: t("tabs.info"), icon: "account_circle"},
            {label: t("tabs.permissions"), icon: "rule"},
            {label: t("tabs.settings"), icon: "settings"}
        ]});

    const tabsEl = (userQuery.data?.role === "ADMIN" || userQuery.isLoading) ? null : <TabsBar {...tabs}/>;

    return userQuery.isLoading ?
        null
        :
        <>
            <Header user={userQuery.data} tabsEl={tabsEl} />
            <Container maxWidth={"xxl"} sx={{mt: 4}}>
                <TabPanel value={tabs.tabValue} index={0}>
                    <Grid container columnSpacing={4} rowSpacing={4}>
                        <Grid item xs={12} sm={8}>
                            <CardBasicInfo user={userQuery.data}
                                           userMutation={userMutation}
                                           emailEditable
                                           workgroupsEditable={userQuery.data?.role !== "ADMIN"}
                                           groupsEditable={userQuery.data?.role === "WG_USER"}
                                           canConfirmEmail={Boolean(workgroupAuthorization?.users?.confirmEmail)}
                                           notesEditable={true}
                                           statusEditable/>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <CardPassword user={userQuery.data}
                                          userMutation={userPwdMutation}/>
                        </Grid>
                        <Grid item xs={12} sm={8}>
                            <CardContact user={userQuery.data}
                                         userMutation={userContactMutation}/>
                        </Grid>
                    </Grid>
                </TabPanel>
                <TabPanel value={tabs.tabValue} index={1}>
                    <PermissionsPanel user={userQuery.data}/>
                </TabPanel>
                <TabPanel value={tabs.tabValue} index={2}>
                    <SettingsCard user={userQuery.data}/>
                </TabPanel>
            </Container>
        </>
}

const PermissionsPanel = ({user}) => {
    if (user.role === "WG_ADMIN") {
        return <WorkgroupPermissions user={user} />
    }
    else if (user.role === "WG_USER") {
        return <StationPermissions user={user} />
    }
}


export default User;